<template>
  <SectionTemplate
    title="不想从零开始？直接套用高质量模板，秒级出片"
    desc="数千款专业级模板，覆盖讲解、营销、培训等各类场景。选好模板、替换内容，几分钟就能生成专业视频，不用拍、不用剪，效率翻倍。"
  >
    <div class="container">
      <div class="templates">
        <div v-for="(item, idx) in calList" :key="idx" class="template-item">
          <template v-if="!!item">
            <CardItem
              :data="item"
              :auto-scale="true"
              :previewing="previewingTemplateId === item.id"
              :source="TEMPLATE_SOURCE.TEMPLATE_PAGE"
              mode="free"
              @cover-click="onHandleCoverClick(item)"
              @preview-click="onHandlePreviewClick(item)"
            >
              {{ item.name }}
            </CardItem>
          </template>
          <template v-else-if="loading">
            <div class="template-item-empty">
              <div class="w-full pt-[56%] max-h-[220px] bg-gray-200 rounded-md"></div>
              <a-skeleton active :paragraph="{ rows: 1 }" />
            </div>
          </template>
        </div>
      </div>
      <SSButton variant="border-white-middle" class="show-more-btn" @click="handleMore">
        查看更多模板
        <ArrowRight class="text-[22px]" />
      </SSButton>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import type { Template } from '@/api/interface';
import { useBreakpoint } from '@rendora/design/index';
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import SSButton from '@/design/components/buttons/base.vue';
import { getTemplateSearch } from '~/api';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import CardItem from '~/features/template/components/cardItem.vue';
import { useTemplateDetail } from '~/hooks/useModal/modals/template';

provideResourceLocation({
  source: SOURCE.CHARACTER,
});

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);
const calList = ref<Template[]>([]);
const loading = ref(false);
const previewingTemplateId = ref<number | null>(null);

const onHandleCoverClick = (item: Template) => {
  if (isMobile.value) {
    if (previewingTemplateId.value !== item.id) {
      previewingTemplateId.value = item.id;
      return;
    }
    previewingTemplateId.value = null;
  }

  navigateTo(`/template/${item.id}.html`, { open: { target: '_blank' } });
};

const onHandlePreviewClick = (item: Template) => {
  previewingTemplateId.value = null;
  useTemplateDetail([item], item, {
    templateSource: TEMPLATE_SOURCE.HOMEPAGE,
    source: SOURCE.TEMPLATE_CENTER,
  });
};

const handleMore = () => {
  previewingTemplateId.value = null;
  navigateTo(`/template`, { open: { target: '_blank' } });
};

const resolution = ref('1920x1080');

const fetchTemplateList = async () => {
  loading.value = true;
  const res = await getTemplateSearch({
    page: 1,
    page_size: 20,
    resolution: resolution.value,
    sort_rank: 1,
    is_template_center_template: 1,
    o: 'score',
    platform: 0,
    online_status: 0,
    query_star: false,
  }).finally(() => {
    loading.value = false;
  });

  calList.value = res.data?.results || [];

  return res;
};

onMounted(async () => {
  await fetchTemplateList();
});

watch(isMobile, value => {
  if (!value) {
    previewingTemplateId.value = null;
  }
});
</script>

<style lang="scss" scoped src="./mobile.scss" />
<style lang="scss" scoped src="./pc.scss" />
